import { defineStore } from 'pinia';
import {
    isBookingEngineerOnly as roleIsBookingEngineerOnly,
    resolveDefaultHomePathFromAdmin,
    shouldUseConsultationWorkspaceHome
} from '@/utils/consultantHome';

export const useAdminInfo = defineStore('adminInfo', {
    state: () => ({
        email: '',
        id: '',
        name: '',
        core_member_id: null,
        is_consultant_manager: false,
        roles: [],
        isLoaded: false
    }),

    actions: {
        getAdminInfo() {
            if (this.isLoaded) {
                return this.adminPayload;
            }
            this.loadFromStorage();
            return this.adminPayload;
        },

        setAdminInfo(adminData) {
            this.email = adminData.email;
            this.id = adminData.id;
            this.name = adminData.name;
            this.core_member_id = adminData.core_member_id ?? null;
            this.is_consultant_manager = Boolean(adminData.is_consultant_manager);
            this.roles = Array.isArray(adminData.roles) ? adminData.roles : [];
            this.isLoaded = true;

            localStorage.setItem(
                'adminInfo',
                JSON.stringify({
                    email: this.email,
                    id: this.id,
                    name: this.name,
                    core_member_id: this.core_member_id,
                    is_consultant_manager: this.is_consultant_manager,
                    roles: this.roles
                })
            );
        },

        loadFromStorage() {
            const storedInfo = localStorage.getItem('adminInfo');
            if (storedInfo) {
                const adminData = JSON.parse(storedInfo);
                this.email = adminData.email;
                this.id = adminData.id;
                this.name = adminData.name;
                this.core_member_id = adminData.core_member_id ?? null;
                this.is_consultant_manager = Boolean(adminData.is_consultant_manager);
                this.roles = Array.isArray(adminData.roles) ? adminData.roles : [];
                this.isLoaded = true;
            }
        },

        clearAdminInfo() {
            this.email = '';
            this.id = '';
            this.name = '';
            this.core_member_id = null;
            this.is_consultant_manager = false;
            this.roles = [];
            this.isLoaded = false;
            localStorage.removeItem('adminInfo');
        }
    },

    getters: {
        hasAdminInfo: (state) => state.isLoaded,

        adminPayload: (state) => ({
            email: state.email,
            id: state.id,
            name: state.name,
            core_member_id: state.core_member_id,
            is_consultant_manager: state.is_consultant_manager,
            roles: state.roles
        }),

        isConsultantOnly: (state) =>
            shouldUseConsultationWorkspaceHome(state.roles || []),

        isBookingEngineerOnly: (state) =>
            roleIsBookingEngineerOnly(state.roles || []),

        defaultHomePath: (state) =>
            resolveDefaultHomePathFromAdmin({ roles: state.roles || [] })
    }
});
